// React
import React, { Component } from "react";

// Components
import HiddenMenu from './HiddenMenu';
import { RefreshButton } from '../../Components';

// Styles
import './panels.css';

class PanelHeading extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            menuClass : 'hamburger hamburger--3dx',
            showHiddenMenu : false,
            showDescription : false
        };
            
            
    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('PanelHeading.componentDidMount()');

    }

    // Opens and closes the meun
    openMenu = () => {
        var newMenu = 'hamburger hamburger--3dx';
        
        if(this.state.menuClass === 'hamburger hamburger--3dx')
            newMenu += ' is-active';
         
        this.setState((prevState, props) => {
            return {
                menuClass: newMenu,
                showHiddenMenu: !prevState.showHiddenMenu
            }
        });
    }


    toggleDescription = () => {

        this.setState((prevState, props) => {
            return {
                showDescription : !this.state.showDescription
            }
        });

    }

/**********************************************************
 *  Render
 **********************************************************/

    buildRefreshButton() {

        if(this.props.refresh === null) 
            return null;
        else {

            return (
                <RefreshButton onClick={this.props.refresh}/>
            )

        }

    }

    // Returns the menu button if it's required
    buildMenuButton = () => {

        if(this.props.hiddenMenu) {
            return (
                <button className={this.state.menuClass} type="button" onClick={this.openMenu}>
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </button>
            );
        }
        else {
            return null;
        }

    }

    // Returns the hidden menu
    buildHiddenMenu = () => {

        if(this.props.hiddenMenu) {
            return (<HiddenMenu show={this.state.showHiddenMenu}>{this.props.children}</HiddenMenu>);
        }
        else {
            return (this.props.children);
        }

    }

    // Returns the hidden menu
    buildDescription = () => {

        if(this.state.showDescription) {
            return (
                <div className='panel-description'>
                    <ul>
                    { this.props.description.map( (point) => { 
                        return (<li className='point'>{point}</li>) 
                    })}
                    </ul>
                </div>
            );
        }
        else {
            return null;
        }

    }

    // Shows the sample label
    showSampleTag = () => {

        if(this.props.sample)
            return (<div className="sample-data">sample</div>);
        else
            return null;

    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('PanelHeading.render()');

    return (

        <div className="panel-heading">

            <h5 className="panel-title">{ this.props.title }</h5>

            <div className="panel-info-icon" onClick={ this.toggleDescription }>
                <i className={this.state.showDescription ? 'icon-cross2 tooltip-icon' : 'icon-bubble-lines4 tooltip-icon'}></i>
            </div>

            { this.buildMenuButton() }

            { this.showSampleTag() }

            { this.buildRefreshButton() }

            { this.buildHiddenMenu() }

            { this.buildDescription() }
            
        </div>

    );
  }
}

export default PanelHeading;





// WEBPACK FOOTER //
// ./src/Components/Panels/PanelHeading.js